import React from "react";
import Marquee from "react-fast-marquee";

const WORDS = [
  "Charity Balls",
  "Business Awards",
  "Highland Balls",
  "Debutantes",
  "Livery Dinners",
  "Regimental Nights",
  "White-Tie",
  "Black-Tie",
];

export const EditorialMarquee = () => {
  return (
    <section
      data-testid="editorial-marquee"
      className="relative bg-[color:var(--bt-bg)] py-14 md:py-20 border-y border-[color:var(--bt-gold-line)] overflow-hidden"
      aria-hidden
    >
      <Marquee speed={30} gradient={false} pauseOnHover={false}>
        {WORDS.concat(WORDS).map((word, i) => (
          <span key={i} className="flex items-center">
            <span className="marquee-text text-[13vw] md:text-[10vw] leading-none px-6 md:px-10 text-[color:var(--bt-ink)]/70">
              {word}
            </span>
            <span className="font-serif-display text-[10vw] md:text-[7vw] leading-none text-[color:var(--bt-gold)]">
              ✦
            </span>
          </span>
        ))}
      </Marquee>
    </section>
  );
};

export default EditorialMarquee;
